import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyWorkPermitsState } from './my-work-permits.state';

const selectState = createFeatureSelector<MyWorkPermitsState>('myWorkPermits');

export const selectMyWorkPermits = createSelector(selectState, state => state.myWorkPermits);
export const selectMyWorkPermit = createSelector(selectState, state => state.myWorkPermit);
export const selectLoadingMyWorkPermit = createSelector(selectState, state => state.loadingMyWorkPermit);
export const selectRemovingFileIds = createSelector(selectState, state => state.removingFileIds);
